const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioIdAlumneIdValidar = async ( idInst: string, idAlu: string, estat: string, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/${idInst}/alumne/${idAlu}/validar/${estat}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) {
            console.log(await response.text());
        }
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
